// import React, { useContext, useState, useEffect } from 'react';
// import { NavLink, useNavigate } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext';
// import '../styles/Sidebar.css';

// /** Small, consistent icon components (stroke-based, currentColor) */
// const Icon = {
//     Dashboard: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <rect x="3" y="3" width="8" height="8" rx="2" />
//             <rect x="13" y="3" width="8" height="5" rx="2" />
//             <rect x="13" y="10" width="8" height="11" rx="2" />
//             <rect x="3" y="13" width="8" height="8" rx="2" />
//         </svg>
//     ),
//     Users: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <circle cx="9" cy="8" r="3" />
//             <path d="M3.5 19c0-3.3 2.8-6 6.2-6s6.2 2.7 6.2 6" />
//             <circle cx="17.5" cy="9" r="2.5" />
//             <path d="M14.5 14c2.7 0 5 2.2 5 5" />
//         </svg>
//     ),
//     Courses: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h9A2.5 2.5 0 0 1 18 6.5V20l-4.5-2L9 20V6.5" />
//             <path d="M6 8h9" />
//         </svg>
//     ),
//     Students: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <path d="M12 3 21 8l-9 5L3 8l9-5z" />
//             <path d="M7 10v4.5a9 9 0 0 0 10 0V10" />
//             <path d="M18 9v4" />
//         </svg>
//     ),
//     Payments: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <rect x="3" y="5" width="18" height="14" rx="2" />
//             <path d="M3 9h18" />
//             <rect x="6" y="13" width="6" height="2" rx="1" />
//         </svg>
//     ),
//     SessionLogs: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <rect x="5" y="3" width="14" height="18" rx="2" />
//             <path d="M8 8h8M8 12h8M8 16h5" />
//             <path d="M9 3v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V3" />
//         </svg>
//     ),
//     Teachers: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <rect x="3" y="4" width="18" height="11" rx="2" />
//             <path d="M12 15v5M8 20h8" />
//             <circle cx="7" cy="10" r="1.5" />
//             <path d="M9 12h5" />
//         </svg>
//     ),
//     Staff: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <circle cx="12" cy="8" r="3.2" />
//             <path d="M4 20c0-4.1 3.6-7 8-7s8 2.9 8 7" />
//         </svg>
//     ),
//     Tag: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <path d="M11 3H5a2 2 0 0 0-2 2v6l10 10 8-8L11 3z" />
//             <circle cx="7.5" cy="7.5" r="1.5" />
//         </svg>
//     ),
//     Expenses: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <circle cx="12" cy="12" r="9" />
//             <path d="M8.5 10.5c0-1.1 1-2 2.7-2H13a2.3 2.3 0 0 1 0 4.6h-2a2.3 2.3 0 0 0 0 4.6h2.2c1.6 0 2.3-.7 2.3-1.9" />
//             <path d="M12 6v12" />
//         </svg>
//     ),
//     Settings: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <circle cx="12" cy="12" r="3" />
//             <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.6v-.2h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1z" />
//         </svg>
//     ),
//     Device: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="2" width="10" height="20" rx="2" /><path d="M10 5h4M11 18h2" /></svg>
//     ),
//     Logout: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <path d="M15 17v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v2" />
//             <path d="M10 12h10M17 9l3 3-3 3" />
//         </svg>
//     ),
//     ChevronRight: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <path d="M9 6l6 6-6 6" />
//         </svg>
//     ),
//     ChevronLeft: () => (
//         <svg viewBox="0 0 24 24" aria-hidden="true">
//             <path d="M15 6l-6 6 6 6" />
//         </svg>
//     ),
// };

// export default function Sidebar() {
//     const { user, logout } = useContext(AuthContext);
//     const navigate = useNavigate();

//     // initial collapsed based on device width
//     const [isCollapsed, setIsCollapsed] = useState(() => window.innerWidth <= 768);

//     // auto-collapse on mobile resize
//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth <= 768) setIsCollapsed(true);
//         };
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     // body class toggle
//     useEffect(() => {
//         if (isCollapsed) document.body.classList.add('sidebar-collapsed');
//         else document.body.classList.remove('sidebar-collapsed');
//         return () => document.body.classList.remove('sidebar-collapsed');
//     }, [isCollapsed]);

//     const linkClass = ({ isActive }: { isActive: boolean }) =>
//         isActive ? 'nav-item active' : 'nav-item';

//     return (
//         <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`} role="navigation" aria-label="Sidebar">
//             <div className="sidebar-header">
//                 <div className="logo" aria-label="Brand">
//                     <img
//                         src={process.env.REACT_APP_COMPANY_LOGO || '/cktmc.svg'}
//                         alt={`${process.env.REACT_APP_COMPANY_NAME || 'Care Kathmandu'} Logo`}
//                         className="logo-img-side"
//                     />
//                 </div>

//                 <button
//                     className="sidebar-toggle"
//                     onClick={() => setIsCollapsed(!isCollapsed)}
//                     title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
//                     aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
//                     type="button"
//                 >
//                     {isCollapsed ? <Icon.ChevronRight /> : <Icon.ChevronLeft />}
//                 </button>
//             </div>

//             <div className="nav-section">
//                 <NavLink to="/dashboard" className={linkClass} title="Dashboard">
//                     <span className="nav-icon"><Icon.Dashboard /></span>
//                     <span className="nav-text">Dashboard</span>
//                 </NavLink>

//                 {user && user.role !== 'viewer' && (
//                     <NavLink to="/users" className={linkClass} title="Users">
//                         <span className="nav-icon"><Icon.Users /></span>
//                         <span className="nav-text">Users</span>
//                     </NavLink>
//                 )}

//                 <NavLink to="/courses" className={linkClass} title="Courses">
//                     <span className="nav-icon"><Icon.Courses /></span>
//                     <span className="nav-text">Courses</span>
//                 </NavLink>

//                 {user && <NavLink to="/mobile/content" className={linkClass} title="Content Operations">
//                     <span className="nav-icon"><Icon.Device /></span>
//                     <span className="nav-text">Content Operations</span>
//                 </NavLink>}
//                 {user && <NavLink to="/mobile/accounts" className={linkClass} title="Mobile Operations">
//                     <span className="nav-icon"><Icon.Users /></span>
//                     <span className="nav-text">Mobile Operations</span>
//                 </NavLink>}
//                 {user && ['admin', 'superadmin'].includes(user.role) && <NavLink to="/mobile/account-setup" className={linkClass} title="Mobile Account Setup">
//                     <span className="nav-icon"><Icon.Device /></span>
//                     <span className="nav-text">Account Setup</span>
//                 </NavLink>}

//                 {user && (
//                     <>
//                         <NavLink to="/students" className={linkClass} title="Students">
//                             <span className="nav-icon"><Icon.Students /></span>
//                             <span className="nav-text">Students</span>
//                         </NavLink>

//                         <NavLink to="/payments" className={linkClass} title="Payments">
//                             <span className="nav-icon"><Icon.Payments /></span>
//                             <span className="nav-text">Payments</span>
//                         </NavLink>

//                         <NavLink to="/session-logs" className={linkClass} title="Session Logs">
//                             <span className="nav-icon"><Icon.SessionLogs /></span>
//                             <span className="nav-text">Session Logs</span>
//                         </NavLink>
//                     </>
//                 )}

//                 {user && user.role !== 'viewer' && (
//                     <>
//                         <NavLink to="/teachers" className={linkClass} title="Teachers">
//                             <span className="nav-icon"><Icon.Teachers /></span>
//                             <span className="nav-text">Teachers</span>
//                         </NavLink>

//                         <NavLink to="/staff" className={linkClass} title="Staff">
//                             <span className="nav-icon"><Icon.Staff /></span>
//                             <span className="nav-text">Staff</span>
//                         </NavLink>
//                     </>
//                 )}

//                 {user && ['admin', 'superadmin'].includes(user.role) && (
//                     <>
//                         <NavLink to="/mobile/device-changes" className={linkClass} title="Device Changes">
//                             <span className="nav-icon"><Icon.Device /></span>
//                             <span className="nav-text">Device Changes</span>
//                         </NavLink>
//                         <NavLink to="/subcategories" className={linkClass} title="Expense Categories">
//                             <span className="nav-icon"><Icon.Tag /></span>
//                             <span className="nav-text">Expense Categories</span>
//                         </NavLink>

//                         <NavLink to="/expenses" className={linkClass} title="Expenses">
//                             <span className="nav-icon"><Icon.Expenses /></span>
//                             <span className="nav-text">Expenses</span>
//                         </NavLink>
//                     </>
//                 )}

//                 {user?.role === 'superadmin' && (
//                     <NavLink to="/settings" className={linkClass} title="Settings">
//                         <span className="nav-icon"><Icon.Settings /></span>
//                         <span className="nav-text">Settings</span>
//                     </NavLink>
//                 )}
//             </div>

//             <div className="logout-section">
//                 {user && (
//                     <button
//                         className="logout-btn"
//                         onClick={() => {
//                             logout();
//                             navigate('/');
//                         }}
//                         title="Logout"
//                         aria-label="Logout"
//                         type="button"
//                     >
//                         <span className="nav-icon"><Icon.Logout /></span>
//                         <span className="nav-text">Logout</span>
//                     </button>
//                 )}
//             </div>
//         </aside>
//     );
// }

import React, { useContext, useEffect, useState } from "react";

import { NavLink, useLocation, useNavigate } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";

/*
 * Keep this temporarily.
 * The new Sidebar UI itself is Tailwind-only.
 *
 * This CSS file will contain ONLY layout compatibility
 * for older pages that still use .main-container,
 * .dashboard-content, etc.
 */
import "../styles/Sidebar.css";

/* =========================================================
   CONSTANTS
========================================================= */

const MOBILE_BREAKPOINT = 768;

const SIDEBAR_STORAGE_KEY = "care-sidebar-collapsed";

/* =========================================================
   ICONS
========================================================= */

const Icon = {
  Dashboard: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="3" width="8" height="8" rx="2" />
      <rect x="13" y="3" width="8" height="5" rx="2" />
      <rect x="13" y="10" width="8" height="11" rx="2" />
      <rect x="3" y="13" width="8" height="8" rx="2" />
    </svg>
  ),

  Users: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 19c0-3.3 2.8-6 6.2-6s6.2 2.7 6.2 6" />
      <circle cx="17.5" cy="9" r="2.5" />
      <path d="M14.5 14c2.7 0 5 2.2 5 5" />
    </svg>
  ),

  Courses: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h9A2.5 2.5 0 0 1 18 6.5V20l-4.5-2L9 20V6.5" />
      <path d="M6 8h9" />
    </svg>
  ),

  LiveClasses: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M8 3v4M16 3v4M3 9h18"/><circle cx="12" cy="14" r="2.5"/></svg>
  ),

  Students: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3 21 8l-9 5L3 8l9-5z" />
      <path d="M7 10v4.5a9 9 0 0 0 10 0V10" />
      <path d="M18 9v4" />
    </svg>
  ),

  Payments: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 9h18" />
      <rect x="6" y="13" width="6" height="2" rx="1" />
    </svg>
  ),

  SessionLogs: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M8 8h8M8 12h8M8 16h5" />
      <path d="M9 3v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V3" />
    </svg>
  ),

  Teachers: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="4" width="18" height="11" rx="2" />
      <path d="M12 15v5M8 20h8" />
      <circle cx="7" cy="10" r="1.5" />
      <path d="M9 12h5" />
    </svg>
  ),

  Staff: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="3.2" />
      <path d="M4 20c0-4.1 3.6-7 8-7s8 2.9 8 7" />
    </svg>
  ),

  Tag: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M11 3H5a2 2 0 0 0-2 2v6l10 10 8-8L11 3z" />
      <circle cx="7.5" cy="7.5" r="1.5" />
    </svg>
  ),

  Expenses: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 10.5c0-1.1 1-2 2.7-2H13a2.3 2.3 0 0 1 0 4.6h-2a2.3 2.3 0 0 0 0 4.6h2.2c1.6 0 2.3-.7 2.3-1.9" />
      <path d="M12 6v12" />
    </svg>
  ),

  Settings: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="3" />

      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.6v-.2h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1z" />
    </svg>
  ),

  Device: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="7" y="2" width="10" height="20" rx="2" />
      <path d="M10 5h4M11 18h2" />
    </svg>
  ),

  Logout: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M15 17v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v2" />
      <path d="M10 12h10M17 9l3 3-3 3" />
    </svg>
  ),

  ChevronRight: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 6l6 6-6 6" />
    </svg>
  ),

  ChevronLeft: () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M15 6l-6 6 6 6" />
    </svg>
  ),
};

/* =========================================================
   TYPES
========================================================= */

type SidebarIcon = () => React.ReactElement;

type SidebarItem = {
  label: string;
  to: string;
  icon: SidebarIcon;
  visible: boolean;
};

/* =========================================================
   COMPONENT
========================================================= */

export default function Sidebar() {
  const { user, logout } = useContext(AuthContext);

  const navigate = useNavigate();

  const location = useLocation();

  /* =====================================================
       RESPONSIVE STATE
    ===================================================== */

  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.innerWidth <= MOBILE_BREAKPOINT
      : false,
  );

  /*
   * Desktop collapsed preference.
   *
   * Mobile uses a separate "mobileOpen" state.
   */
  const [desktopCollapsed, setDesktopCollapsed] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }

    return window.localStorage.getItem(SIDEBAR_STORAGE_KEY) === "true";
  });

  const [mobileOpen, setMobileOpen] = useState(false);

  /*
   * What the Sidebar itself visually looks like.
   *
   * Desktop:
   *   desktopCollapsed controls it.
   *
   * Mobile:
   *   collapsed rail unless opened.
   */
  const visualCollapsed = isMobile ? !mobileOpen : desktopCollapsed;

  /* =====================================================
       WINDOW SIZE
    ===================================================== */

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;

      setIsMobile(mobile);

      /*
       * Never carry an open
       * mobile drawer across
       * breakpoint changes.
       */
      if (!mobile) {
        setMobileOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* =====================================================
       CLOSE MOBILE DRAWER AFTER ROUTE CHANGE
    ===================================================== */

  useEffect(() => {
    if (isMobile) {
      setMobileOpen(false);
    }
  }, [location.pathname, isMobile]);

  /* =====================================================
       BODY LAYOUT CLASS
    ===================================================== */

  useEffect(() => {
    /*
     * On mobile the page always uses
     * the compact 76px layout even
     * while the full drawer is opened
     * over the content.
     */
    const layoutCollapsed = isMobile || desktopCollapsed;

    document.body.classList.toggle("sidebar-collapsed", layoutCollapsed);

    document.body.classList.toggle("sidebar-mobile", isMobile);

    return () => {
      document.body.classList.remove("sidebar-collapsed");

      document.body.classList.remove("sidebar-mobile");
    };
  }, [isMobile, desktopCollapsed]);

  /* =====================================================
       TOGGLE
    ===================================================== */

  const toggleSidebar = () => {
    if (isMobile) {
      setMobileOpen((current) => !current);

      return;
    }

    setDesktopCollapsed((current) => {
      const next = !current;

      window.localStorage.setItem(SIDEBAR_STORAGE_KEY, String(next));

      return next;
    });
  };

  /* =====================================================
       ACTIVE ROUTE
    ===================================================== */

  const isRouteActive = (to: string) => {
    const pathname = location.pathname;

    /*
     * All Mobile Administration
     * sub-pages belong to the
     * Mobile Operations sidebar item.
     */
    if (to === "/mobile/accounts") {
      const routes = [
        "/mobile/accounts",
        "/mobile/alerts",
        "/mobile/audit",
        "/mobile/health",
        "/mobile/reports",
      ];

      return routes.some(
        (route) => pathname === route || pathname.startsWith(`${route}/`),
      );
    }

    return pathname === to || pathname.startsWith(`${to}/`);
  };

  const mobileAccountItems: SidebarItem[] = [
    {
      label: "Account Setup",
      to: "/mobile/account-setup",
      icon: Icon.Device,
      visible:
        Boolean(user) && ["admin", "superadmin"].includes(user?.role || ""),
    },
    {
      label: "Device Changes",
      to: "/mobile/device-changes",
      icon: Icon.Device,
      visible:
        Boolean(user) && ["admin", "superadmin"].includes(user?.role || ""),
    },
    {
      label: "Content Operations",
      to: "/mobile/content",
      icon: Icon.Device,
      visible: Boolean(user),
    },
    {
      label: "Mobile Operations",
      to: "/mobile/accounts",
      icon: Icon.Users,
      visible: Boolean(user),
    },
  ];

  const visibleMobileAccountItems = mobileAccountItems.filter(
    (item) => item.visible,
  );

  const mobileAccountsActive = visibleMobileAccountItems.some((item) =>
    isRouteActive(item.to),
  );

  const [mobileAccountsOpen, setMobileAccountsOpen] = useState(
    mobileAccountsActive,
  );

  useEffect(() => {
    if (mobileAccountsActive) {
      setMobileAccountsOpen(true);
    }
  }, [mobileAccountsActive]);

  /* =====================================================
       NAV ITEMS
    ===================================================== */

  const items: SidebarItem[] = [
    {
      label: "Dashboard",
      to: "/dashboard",
      icon: Icon.Dashboard,
      visible: true,
    },

    {
      label: "Users",
      to: "/users",
      icon: Icon.Users,
      visible: Boolean(user) && user?.role !== "viewer",
    },

    {
      label: "Courses",
      to: "/courses",
      icon: Icon.Courses,
      visible: true,
    },

    {
      label: "Live Classes",
      to: "/live-classes",
      icon: Icon.LiveClasses,
      visible: Boolean(user),
    },
    {
      label: "Zoom Accounts",
      to: "/zoom-accounts",
      icon: Icon.LiveClasses,
      visible: Boolean(user && ["admin", "superadmin"].includes(user.role)),
    },

    {
      label: "Students",
      to: "/students",
      icon: Icon.Students,
      visible: Boolean(user),
    },

    {
      label: "Payments",
      to: "/payments",
      icon: Icon.Payments,
      visible: Boolean(user),
    },

    {
      label: "Session Logs",
      to: "/session-logs",
      icon: Icon.SessionLogs,
      visible: Boolean(user),
    },

    {
      label: "Teachers",
      to: "/teachers",
      icon: Icon.Teachers,
      visible: Boolean(user) && user?.role !== "viewer",
    },

    {
      label: "Staff",
      to: "/staff",
      icon: Icon.Staff,
      visible: Boolean(user) && user?.role !== "viewer",
    },

    {
      label: "Expense Categories",
      to: "/subcategories",
      icon: Icon.Tag,
      visible:
        Boolean(user) && ["admin", "superadmin"].includes(user?.role || ""),
    },

    {
      label: "Expenses",
      to: "/expenses",
      icon: Icon.Expenses,
      visible:
        Boolean(user) && ["admin", "superadmin"].includes(user?.role || ""),
    },

    {
      label: "Settings",
      to: "/settings",
      icon: Icon.Settings,
      visible: user?.role === "superadmin",
    },
  ];

  const visibleItems = items.filter((item) => item.visible);

  const mobileAccountsInsertIndex = visibleItems.findIndex(
    (item) => item.to === "/payments",
  );

  const itemsBeforeMobileAccounts = visibleItems.slice(
    0,
    mobileAccountsInsertIndex + 1,
  );

  const itemsAfterMobileAccounts = visibleItems.slice(
    mobileAccountsInsertIndex + 1,
  );

  /* =====================================================
       LOGOUT
    ===================================================== */

  const handleLogout = () => {
    logout();

    navigate("/");
  };

  /* =====================================================
       RENDER
    ===================================================== */

  return (
    <>
      {/* =============================================
                MOBILE BACKDROP
            ============================================= */}

      {isMobile && mobileOpen && (
        <button
          type="button"
          aria-label="Close sidebar"
          onClick={() => setMobileOpen(false)}
          className="
                            fixed inset-0
                            z-[39]
                            border-0
                            bg-slate-950/25
                            p-0
                            backdrop-blur-[1px]
                        "
        />
      )}

      {/* =============================================
                SIDEBAR
            ============================================= */}

      <aside
        aria-label="Main navigation"
        className={`
                    fixed
                    inset-y-0
                    left-0
                    z-40
                    flex
                    h-screen
                    flex-col
                    border-r
                    border-slate-200
                    bg-white
                    shadow-[4px_0_24px_rgba(15,23,42,0.04)]
                    transition-[width]
                    duration-200
                    ease-out

                    ${visualCollapsed ? "w-[76px]" : "w-[280px]"}
                `}
      >
        {/* =========================================
                    HEADER
                ========================================= */}

        <div
          className={`
                        shrink-0
                        border-b
                        border-slate-100

                        ${
                          visualCollapsed
                            ? "flex flex-col items-center gap-2 px-2 pb-3 pt-4"
                            : "flex h-[106px] items-center justify-between gap-3 px-5"
                        }
                    `}
        >
          {/* Logo */}

          <div
            className={`
                            flex
                            min-w-0
                            items-center
                            justify-center
                            overflow-hidden

                            ${visualCollapsed ? "h-10 w-11" : "h-[72px] flex-1"}
                        `}
          >
            <img
              src={process.env.REACT_APP_COMPANY_LOGO || "/cktmc.svg"}
              alt={`${
                process.env.REACT_APP_COMPANY_NAME || "Care Kathmandu"
              } Logo`}
              className={`
                                block
                                object-contain
                                transition-all
                                duration-200

                                ${
                                  visualCollapsed
                                    ? "max-h-9 max-w-11"
                                    : "max-h-[68px] max-w-[175px]"
                                }
                            `}
            />
          </div>

          {/* Toggle */}

          <button
            type="button"
            onClick={toggleSidebar}
            title={visualCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            aria-label={visualCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            aria-expanded={!visualCollapsed}
            className="
                            grid
                            h-9 w-9
                            shrink-0
                            place-items-center
                            rounded-[9px]
                            border
                            border-slate-200
                            bg-white
                            p-0
                            text-slate-500
                            shadow-sm
                            transition
                            hover:border-slate-300
                            hover:bg-slate-50
                            hover:text-slate-900
                            focus:outline-none
                            focus:ring-2
                            focus:ring-slate-200
                        "
          >
            <span
              className="
                                block
                                h-[18px]
                                w-[18px]

                                [&_svg]:h-full
                                [&_svg]:w-full
                                [&_svg]:fill-none
                                [&_svg]:stroke-current
                                [&_svg]:stroke-[1.8]
                                [&_svg]:stroke-linecap-round
                                [&_svg]:stroke-linejoin-round
                            "
            >
              {visualCollapsed ? <Icon.ChevronRight /> : <Icon.ChevronLeft />}
            </span>
          </button>
        </div>

        {/* =========================================
                    NAVIGATION
                ========================================= */}

        <nav
          className="
                        min-h-0
                        flex-1
                        overflow-y-auto
                        overflow-x-hidden
                        px-2
                        py-3

                        [scrollbar-color:#cbd5e1_transparent]
                        [scrollbar-width:thin]

                        [&::-webkit-scrollbar]:w-1
                        [&::-webkit-scrollbar-track]:bg-transparent
                        [&::-webkit-scrollbar-thumb]:rounded-full
                        [&::-webkit-scrollbar-thumb]:bg-slate-300
                    "
        >
          <div
            className="
                            flex
                            flex-col
                            gap-1
                        "
          >
            {itemsBeforeMobileAccounts.map((item) => {
              const active = isRouteActive(item.to);

              const ItemIcon = item.icon;

              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  title={visualCollapsed ? item.label : undefined}
                  aria-label={item.label}
                  aria-current={active ? "page" : undefined}
                  onClick={() => {
                    if (isMobile) {
                      setMobileOpen(false);
                    }
                  }}
                  className={`
                                            group
                                            relative
                                            flex
                                            h-11
                                            items-center
                                            rounded-[9px]
                                            border
                                            border-transparent
                                            no-underline
                                            transition-all
                                            duration-150

                                            ${
                                              visualCollapsed
                                                ? "justify-center px-0"
                                                : "gap-3 px-3"
                                            }

                                            ${
                                              active
                                                ? "bg-slate-100 text-[#079447]"
                                                : "text-slate-700 hover:bg-slate-50 hover:text-slate-950"
                                            }
                                        `}
                >
                  {/* Active indicator */}

                  {active && (
                    <span
                      aria-hidden="true"
                      className="
                                                    absolute
                                                    left-0
                                                    top-1/2
                                                    h-6
                                                    w-[3px]
                                                    -translate-y-1/2
                                                    rounded-r-full
                                                    bg-[#0aa14b]
                                                "
                    />
                  )}

                  {/* Icon */}

                  <span
                    className={`
                                                grid
                                                h-8 w-8
                                                shrink-0
                                                place-items-center
                                                rounded-lg
                                                transition

                                                ${
                                                  active
                                                    ? "text-[#079447]"
                                                    : "text-slate-600 group-hover:text-slate-900"
                                                }

                                                [&_svg]:h-[20px]
                                                [&_svg]:w-[20px]
                                                [&_svg]:fill-none
                                                [&_svg]:stroke-current
                                                [&_svg]:stroke-[1.8]
                                                [&_svg]:stroke-linecap-round
                                                [&_svg]:stroke-linejoin-round
                                            `}
                  >
                    <ItemIcon />
                  </span>

                  {/* Text */}

                  {!visualCollapsed && (
                    <span
                      className={`
                                                    min-w-0
                                                    flex-1
                                                    truncate
                                                    text-[13px]

                                                    ${
                                                      active
                                                        ? "font-semibold"
                                                        : "font-medium"
                                                    }
                                                `}
                    >
                      {item.label}
                    </span>
                  )}
                </NavLink>
              );
            })}

            {visibleMobileAccountItems.length > 0 && (
              <div className="flex flex-col gap-1">
                <button
                  type="button"
                  onClick={() => setMobileAccountsOpen((open) => !open)}
                  title={visualCollapsed ? "Mobile Accounts" : undefined}
                  aria-label="Mobile Accounts"
                  aria-expanded={mobileAccountsOpen}
                  aria-controls="mobile-accounts-navigation"
                  className={`
                    group
                    relative
                    flex
                    h-11
                    w-full
                    items-center
                    rounded-[9px]
                    border
                    border-transparent
                    bg-transparent
                    text-left
                    transition-all
                    duration-150

                    ${visualCollapsed ? "justify-center px-0" : "gap-3 px-3"}

                    ${
                      mobileAccountsActive
                        ? "bg-slate-100 text-[#079447]"
                        : "text-slate-700 hover:bg-slate-50 hover:text-slate-950"
                    }
                  `}
                >
                  {mobileAccountsActive && (
                    <span
                      aria-hidden="true"
                      className="absolute left-0 top-1/2 h-6 w-[3px] -translate-y-1/2 rounded-r-full bg-[#0aa14b]"
                    />
                  )}

                  <span
                    className={`
                      grid
                      h-8 w-8
                      shrink-0
                      place-items-center
                      rounded-lg
                      transition

                      ${
                        mobileAccountsActive
                          ? "text-[#079447]"
                          : "text-slate-600 group-hover:text-slate-900"
                      }

                      [&_svg]:h-[20px]
                      [&_svg]:w-[20px]
                      [&_svg]:fill-none
                      [&_svg]:stroke-current
                      [&_svg]:stroke-[1.8]
                      [&_svg]:stroke-linecap-round
                      [&_svg]:stroke-linejoin-round
                    `}
                  >
                    <Icon.Users />
                  </span>

                  {!visualCollapsed && (
                    <>
                      <span
                        className={`min-w-0 flex-1 truncate text-[13px] ${
                          mobileAccountsActive ? "font-semibold" : "font-medium"
                        }`}
                      >
                        Mobile Accounts
                      </span>
                      <span
                        aria-hidden="true"
                        className={`grid h-5 w-5 shrink-0 place-items-center transition-transform duration-200 ${
                          mobileAccountsOpen ? "rotate-90" : ""
                        } [&_svg]:h-4 [&_svg]:w-4 [&_svg]:fill-none [&_svg]:stroke-current [&_svg]:stroke-2`}
                      >
                        <Icon.ChevronRight />
                      </span>
                    </>
                  )}
                </button>

                {mobileAccountsOpen && (
                  <div
                    id="mobile-accounts-navigation"
                    className={`flex flex-col gap-1 ${
                      visualCollapsed
                        ? ""
                        : "ml-4 border-l border-slate-200 pl-2"
                    }`}
                  >
                    {visibleMobileAccountItems.map((item) => {
                      const active = isRouteActive(item.to);
                      const ItemIcon = item.icon;

                      return (
                        <NavLink
                          key={item.to}
                          to={item.to}
                          title={visualCollapsed ? item.label : undefined}
                          aria-label={item.label}
                          aria-current={active ? "page" : undefined}
                          onClick={() => {
                            if (isMobile) {
                              setMobileOpen(false);
                            }
                          }}
                          className={`
                            group
                            relative
                            flex
                            h-11
                            items-center
                            rounded-[9px]
                            border
                            border-transparent
                            no-underline
                            transition-all
                            duration-150

                            ${visualCollapsed ? "justify-center px-0" : "gap-3 px-3"}

                            ${
                              active
                                ? "bg-slate-100 text-[#079447]"
                                : "text-slate-700 hover:bg-slate-50 hover:text-slate-950"
                            }
                          `}
                        >
                          {active && (
                            <span
                              aria-hidden="true"
                              className="absolute left-0 top-1/2 h-6 w-[3px] -translate-y-1/2 rounded-r-full bg-[#0aa14b]"
                            />
                          )}

                          <span
                            className={`
                              grid
                              h-8 w-8
                              shrink-0
                              place-items-center
                              rounded-lg
                              transition

                              ${
                                active
                                  ? "text-[#079447]"
                                  : "text-slate-600 group-hover:text-slate-900"
                              }

                              [&_svg]:h-[20px]
                              [&_svg]:w-[20px]
                              [&_svg]:fill-none
                              [&_svg]:stroke-current
                              [&_svg]:stroke-[1.8]
                              [&_svg]:stroke-linecap-round
                              [&_svg]:stroke-linejoin-round
                            `}
                          >
                            <ItemIcon />
                          </span>

                          {!visualCollapsed && (
                            <span
                              className={`min-w-0 flex-1 truncate text-[13px] ${
                                active ? "font-semibold" : "font-medium"
                              }`}
                            >
                              {item.label}
                            </span>
                          )}
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {itemsAfterMobileAccounts.map((item) => {
              const active = isRouteActive(item.to);
              const ItemIcon = item.icon;

              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  title={visualCollapsed ? item.label : undefined}
                  aria-label={item.label}
                  aria-current={active ? "page" : undefined}
                  onClick={() => {
                    if (isMobile) {
                      setMobileOpen(false);
                    }
                  }}
                  className={`group relative flex h-11 items-center rounded-[9px] border border-transparent no-underline transition-all duration-150 ${
                    visualCollapsed ? "justify-center px-0" : "gap-3 px-3"
                  } ${
                    active
                      ? "bg-slate-100 text-[#079447]"
                      : "text-slate-700 hover:bg-slate-50 hover:text-slate-950"
                  }`}
                >
                  {active && (
                    <span
                      aria-hidden="true"
                      className="absolute left-0 top-1/2 h-6 w-[3px] -translate-y-1/2 rounded-r-full bg-[#0aa14b]"
                    />
                  )}
                  <span
                    className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg transition ${
                      active
                        ? "text-[#079447]"
                        : "text-slate-600 group-hover:text-slate-900"
                    } [&_svg]:h-[20px] [&_svg]:w-[20px] [&_svg]:fill-none [&_svg]:stroke-current [&_svg]:stroke-[1.8] [&_svg]:stroke-linecap-round [&_svg]:stroke-linejoin-round`}
                  >
                    <ItemIcon />
                  </span>
                  {!visualCollapsed && (
                    <span
                      className={`min-w-0 flex-1 truncate text-[13px] ${
                        active ? "font-semibold" : "font-medium"
                      }`}
                    >
                      {item.label}
                    </span>
                  )}
                </NavLink>
              );
            })}
          </div>
        </nav>

        {/* =========================================
                    FOOTER / LOGOUT
                ========================================= */}

        {user && (
          <div
            className="
                            shrink-0
                            border-t
                            border-slate-100
                            bg-white
                            p-2.5
                        "
          >
            {!visualCollapsed && (
              <div
                className="
                                    mb-2
                                    px-2
                                    text-[9px]
                                    font-medium
                                    uppercase
                                    tracking-[0.06em]
                                    text-slate-400
                                "
              >
                {user.role}
              </div>
            )}

            <button
              type="button"
              onClick={handleLogout}
              title="Logout"
              aria-label="Logout"
              className={`
                                flex
                                h-10
                                w-full
                                items-center
                                justify-center
                                rounded-[9px]
                                border-0
                                bg-[#0d162a]
                                text-white
                                transition
                                hover:bg-[#172239]
                                focus:outline-none
                                focus:ring-2
                                focus:ring-slate-300
                                focus:ring-offset-1

                                ${visualCollapsed ? "px-0" : "gap-2 px-3"}
                            `}
            >
              <span
                className="
                                    grid
                                    h-7 w-7
                                    shrink-0
                                    place-items-center

                                    [&_svg]:h-5
                                    [&_svg]:w-5
                                    [&_svg]:fill-none
                                    [&_svg]:stroke-current
                                    [&_svg]:stroke-[1.8]
                                    [&_svg]:stroke-linecap-round
                                    [&_svg]:stroke-linejoin-round
                                "
              >
                <Icon.Logout />
              </span>

              {!visualCollapsed && (
                <span
                  className="
                                        text-[12px]
                                        font-semibold
                                    "
                >
                  Logout
                </span>
              )}
            </button>
          </div>
        )}
      </aside>
    </>
  );
}
